module.exports = __webpack_public_path__ + "c4acf0b423eed3a2de3e51b045a4ea9f.pdf";